import React, { useState, useEffect,useRef, useContext } from 'react'
import {FormHelperText, Button, Grid, TextField,Box,Paper,Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useFormik } from 'formik';
import * as yup from 'yup';
import axios from "axios";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import { ca } from 'date-fns/locale';
import { useHistory } from 'react-router-dom';
import { useUrlContext } from '../context/urlContext';
import { useAuth } from '../context/authContext';
import { errorContext } from '../Components/ErrorDisplay';
import { describeError } from '../Components/errorUtils';
import apiConfig from '../config/apiConfig';



 function SinglePassCreation() {
    const { UrlHelperObj } = useUrlContext();
    const {user} = useAuth();
  const { notify } = useContext(errorContext);
  const history = useHistory();
   const muiTheme = useTheme();
   const isMobile = useMediaQuery(muiTheme.breakpoints.down('sm'));
  const initFormValue = { memberId:"",
                          memberName:"",
                          cardNumber:"",
                          promotionId:"",
                          mobile:"+",
                          email:"",
                          token:"",
                          marketFlag:false,
                          timezone:Intl.DateTimeFormat().resolvedOptions().timeZone
                        };
const[cardExpiryDate,setCardExpiryDate] = useState(null);
const [formValue,setFormValue] = useState(initFormValue);
  const [submitted, setSubmitted] = useState(false)
  const [errors, setErrors] = useState({})
  const [message, setMessage] = useState(null)
  const [isErrorMessage, setIsErrorMessage] = useState(false)
  const [errorsName, setErrorsName] = useState("")
  const [errorsMemberId, setErrorsMemberId] = useState("");
  const [errorsCardNumber, setErrorsCardNumber] = useState("")
  const [errorsEmail, setErrorsEmail] = useState("")
  const DEFAULT_PHONE_COUNTRY = 'au'
  const DEFAULT_PHONE_DIAL_CODE = '61'
  
  
  const [countryCode, setCountryCode] = useState(DEFAULT_PHONE_DIAL_CODE)
  const [selectedCountry, setSelectedCountry] = useState(DEFAULT_PHONE_COUNTRY)
  const [phoneResetSeed, setPhoneResetSeed] = useState(0)
  const allowedPhoneCountries = ['au', 'in', 'us']
  const resolvedSelectedCountry = allowedPhoneCountries.includes(selectedCountry)
    ? selectedCountry
    : DEFAULT_PHONE_COUNTRY
  const [isMobileDuplicated,setIsMobileDuplicated] = useState(false);  
  //const [fieldValidCount, setFieldValidCount] = useState(0);
  const [mobilevalid, setMobileValid] = useState(false)
  const [policyChecked,setPolicyChecked] = useState(false);
  const [countValid,setCountValid] = useState(false);
  var logostr=apiConfig.promoImageOrigin;
  const [logoUrl,setLogoUrl]=useState("");//(logostr+"0");
  const[promotionList,setPromotionList] = useState([]);//useState([{id:1,name:"ppp"},{id:2,name:"vvv"},{id:3,name:"cccc"}]);
  
/*
  For omniqpon.co.au
  const REACT_APP_SITE_KEY='6LdAsx4dAAAAABLuJfONcGfzPAXZWpd-snvtlA5c'
  const REACT_APP_SECRET_KEY='6LdAsx4dAAAAALo1lh792x6XPY9ZhznameXA7V0YpqCM'
*/

 //For omniqpon.app
 //const REACT_APP_SITE_KEY='6LdOXZ8gAAAAAO0xb98eP3tKggtrWAD6uZr2sdmA'
 //const REACT_APP_SECRET_KEY='6LdOXZ8gAAAAAGu-WVybwxkyhMTfZ50gMpEbHS0C'

 //For omniqpon.net
 const REACT_APP_SITE_KEY='6Ldq_wsoAAAAAHxSyYh9BeWeNBQ6rja7sZSgfr1q'
 const REACT_APP_SECRET_KEY='6Ldq_wsoAAAAAArMfsDxh_tOkL5hB-EPKZ3VSZcG'

//for localhost
//For checkbox
// const REACT_APP_SITE_KEY='6LcnC9MiAAAAAF9JKccde65-xChP0bZkTHONZ4eB'
// const REACT_APP_SECRET_KEY='6LcnC9MiAAAAAN6Nfq_9nB6CsT_Fvp34yJbvE6Sy'

//For v2 invisible localhost
//const REACT_APP_SITE_KEY='6LfqdAInAAAAADL46raqJYEQq5vpDV87kw6193Di'
//const REACT_APP_SECRET_KEY='6LfqdAInAAAAAGD5j-Om7OSkPDwdRL6I4R_8ibT3'

//v2 invisible omniqpon.app
// const REACT_APP_SITE_KEY='6LdJwgInAAAAALZFxMC0WGwfK9YKXqxifRPX2bb4'
// const REACT_APP_SECRET_KEY='6LdJwgInAAAAALZFxMC0WGwfK9YKXqxifRPX2bb4'

//const reCaptchaRef = useRef(null);

  useEffect(() => {
  //  getPromotionList();
    setCountryCode(DEFAULT_PHONE_DIAL_CODE);
    setSelectedCountry(DEFAULT_PHONE_COUNTRY);
    
  
  }, [])

  useEffect(() => {
    if(promotionList !== null && promotionList.length >0 ){
      setFormValue({
        ...formValue,
        promotionId: promotionList[0].id
      });
    }
     
  }, [promotionList])
/* async  function  getPromotionList(){
  //   const captchaToken = await reCaptchaRef.current.executeAsync();
  // reCaptchaRef.current.reset();
  //setFormValue(formValue => ({...formValue,token:captchaToken}));

    DataService.getPromotion()
      .then(response => response.data)
      .then(results => setPromotionList(results))
      .catch(err => handlePromotionError(err));
} */
function handlePromotionError(err){
  let errors={};
  errors["promo"] = "Error in receiving promotion list";
  setErrors(errors);
}
  // updating state here for name
const onChangeName = async (event) =>{
    //await setName(event.target.value)
    await setFormValue({
      ...formValue,
      memberName: event.target.value
    });
    
    validateName(event);

  }
  
  
  const onChangeCardNumber = async (event) =>{
    //await setName(event.target.value)
    await setFormValue({
      ...formValue,
      cardNumber: event.target.value
    });
    
    validateCardNumber(event);

  }

  const onChangeMemberId = async (event) =>{
    //await setName(event.target.value)
    await setFormValue({
      ...formValue,
      memberId: event.target.value
    });
    
    validateMemberId(event);

  }
  const onChangeEmail = async (event) =>{
    //await setName(event.target.value)
    await setFormValue({
      ...formValue,
      email: event.target.value
    });
    
    validateEmail(event.target.value);

  }
  const validateEmail = (email) => {
    let currentname = email;
    let currentnamevalid = true;
    // let errors = {}
    setErrorsEmail("");
    if (!currentname) {
      currentnamevalid = false;
      setErrorsEmail("Enter valid value");
      
    }
    
    if (typeof currentname !== undefined &&  currentname !== "") {
      if (!currentname.match(/\S+@\S+\.\S+/)) {
        setErrorsEmail("Enter valid value");
        
      }
    }
    
    
  }
  const onChangePromotion = async (event) =>{
    //await setName(event.target.value)
   console.log("ChangePromotion:"+event.target.value);
    await setFormValue({
      ...formValue,
      promotionId: event.target.value
    });
  }

  const handleToken = (token) => {
    console.log("token:"+token);
    //setToken(token);
    setFormValue({
    ...formValue,
    token: token
  });
  }

  //updating state here for mobile
  const onChangeMobile = (phone, ctr) => {
    const incomingCountry = ctr?.countryCode || resolvedSelectedCountry;
    const normalizedCountry = allowedPhoneCountries.includes(incomingCountry) ? incomingCountry : DEFAULT_PHONE_COUNTRY;
    const dialCode = ctr?.dialCode || ({ in: '91', us: '1' }[normalizedCountry] || '61');
    const nextPhoneValue = phone || '';

    setCountryCode(dialCode);
    setSelectedCountry(normalizedCountry);
    formik.setFieldValue('mobile_country_code', dialCode, false);
    formik.setFieldValue('mobile', nextPhoneValue, true);
  }

  const isFormValid = () => {
    let status = false
     let tempErr={};
    
    if (mobilevalid && errorsMemberId==="" && policyChecked &&
          errorsName==="" && errorsCardNumber==="" && errorsEmail==="" )
      status = true;
    
    return status

  }/* 
  const onSubmit = async() => {
    validatePolicyCheckbox()
    validateMobile(formValue.mobile,countryCode);
    setFormValue(formValue => ({...formValue,timezone:Intl.DateTimeFormat().resolvedOptions().timeZone}));
  //  const token = await reRef.cu

  
    let errors = {};
    
    
    console.log(formValue);
    
     DataService.postActionOnSubmit(formValue)
    .then((response) => {
      
      console.log(response.data);
      if(response.data.error === 1)
      {
        errors["duplicate"] = response.data.message;//"Some error at backend server, please try again";
        setIsMobileDuplicated(true);
        setSubmitted(false);
        console.log("CheckPhoneDuplicate : DB Error");
      }
      else
      {
        if(response.data.IsPhoneNumberDuplicated === true)
        {
          errors["duplicate"] = response.data.message;//"Phone is already registered for this Promotion";
          setIsMobileDuplicated(true);
          setSubmitted(false);
          console.log("CheckPhoneDuplicate : Phone is already registered for this Promotion.");
        }
        else
        {
          errors["duplicate"] = "";
          setSubmitted(true);
          setIsMobileDuplicated(false);
          
          console.log("CheckPhoneDuplicate : Phone is not duplicated");
        }
        errors["pass"] = response.data.message;
      }
      setErrors(errors);
    })
    .catch((err) => {
      
      setSubmitted(false);
      errors["duplicate"] = "CONNECTION FAILED: Could not connect to backend server.";
      console.log("CheckPhoneDuplicate :"+err);
      setErrors(errors);
    })
 
    

  } */
  const cancelAll = () => {
    
    window.location.reload(false)
  }

  

  const validateMemberId = (e) => {
    let currentName = e.target.name;
    let currentValue = e.target.value;
    let isValid = true;
    
    setErrorsMemberId("");
    if(!currentValue) {
    
      setErrorsMemberId("Enter valid  value");
    }
     else if(typeof currentValue !== typeof(undefined) ) {
      if(currentName==="memberName" & !currentValue.match(/^[a-z ,.'-]+$/i)) {
    
        setErrorsMemberId("Enter valid  value");
      }
      else if((currentName==="memberId" || currentName==="cardNumber" ) &
               !currentValue.match(/^[a-z0-9.-]+$/i)) {
    
        setErrorsMemberId("Enter valid  value");
      }
      else{
    
        setErrorsMemberId("");
      }
      
    }
  }
  const validateCardNumber = (e) => {
    let currentName = e.target.name;
    let currentValue = e.target.value;
    let isValid = true;
    setErrorsCardNumber("");
    
    if(!currentValue) {
      
      setErrorsCardNumber("Enter valid value");
    }
    else if(typeof currentValue !== typeof(undefined) ) {
      
      if((currentName==="memberId" || currentName==="cardNumber" ) &
               !currentValue.match(/^[a-z0-9.-]+$/i)) {
                setErrorsCardNumber("Enter valid value");
      }

      
    }
    else
        setErrorsCardNumber("");
    
    
  }



  const validateName = (e) => {
    let currentName = e.target.name;
    let currentValue = e.target.value;
    let currentnamevalid = true;
    
    setErrorsName("");
    if(!currentValue) {
      setErrorsName("Enter valid value");
    }
     if(typeof currentValue !== typeof(undefined) ) {
      if(currentName==="memberName" & !currentValue.match(/^[a-z ,.'-]+$/i)) {
        
        setErrorsName("Enter valid value");
      }
      else
        setErrorsName("");
      
    }
    
    
  }

  function handleMarketCheckbox(event)
  {
    
    setFormValue({...formValue,marketFlag:event.target.checked})
    //alert("market"+ event.target.checked);
  }
  function handlePolicyCheckbox(event)
  {
    setPolicyChecked(event.target.checked);
    
  }
  function validatePolicyCheckbox()
  {
    //alert("validatePolicyCheckbox");
    let errors = {}
    if(!policyChecked)
    {
      errors["policy"] = "Please check policy checkbox";
      setErrors(errors);
      return false;
    }
    else 
    {
      errors["policy"] = "";
      setErrors(errors);
      return true;
    }
    
  }
  function tenFunc(i){
        return(i<10?'0':'')+i;
    }
  function handleChangeCardExpiryDate(date){
    
        /* setCardExpiryDate(date);
        var toDateStr = date.getFullYear()+"-"+date.getMonth()+1+"-"+tenFunc(date.getDate());
        formik.setFieldValue("cardexpiry_date",toDateStr);
        formik.setFieldTouched("cardexpiry_date", true); */
setCardExpiryDate(date);
        if (date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');  
    const day = String(date.getDate()).padStart(2, '0');         
    const dateStr = `${year}-${month}-${day}`;      
    var toDateStr = dateStr;           
    console.log("toDateStr:"+toDateStr);
    formik.setFieldValue("cardexpiry_date", toDateStr, true);
    formik.setFieldTouched("cardexpiry_date", true, true);
  } else {
    formik.setFieldValue("cardexpiry_date", '', true);
    formik.setFieldTouched("cardexpiry_date", true, true);
    formik.validateField("cardexpiry_date");
  }
    
  }
  const validateMobile = (onlymobile,ctrCode) => {
    
    //let onlymobile = mobile
    let mobilevalid = true
    let errors = {}
    
    if (!onlymobile) {
      mobilevalid = false;
      errors["mobile"] = "Cannot be empty";
    }
    if (typeof onlymobile !== "undefined") {
      console.log("In undef")
      //onlymobile = "+" + onlymobile
      ////(^d{1,4}[- ]?)?\d{10}$/)) {
      console.log(onlymobile);
      let regex ;
      if(ctrCode ==='91')
      {
        
        regex = RegExp(/^(\+?91|0)?[6789]\d{9}$/);
      }
      /*else if(ctrCode ==='1')
      {
        
        regex = RegExp(/^((\+1|1)?( |-)?)?(\([2-9][0-9]{2}\)|[2-9][0-9]{2})( |-)?([2-9][0-9]{2}( |-)?[0-9]{4})$/);
      }*/
      else if(ctrCode === '61')
      {
        
        regex = RegExp(/^(\+?61|0)4\d{8}$/);
      }
      //For AU if (!onlymobile.match())
      
     // if (!onlymobile.match())
      
      //if(!onlymobile.match(regex))
      if(!regex.test(onlymobile))
      {  
        //console.log("In valid")
        console.log("Check Valid");
        mobilevalid = false;
        errors["mobile"] = "Enter valid mobile number";
      }
      else
        errors["mobile"] = ""
    }
    console.log("Mobile valid" + mobilevalid)
    setErrors(errors)
    setMobileValid(mobilevalid)
    return mobilevalid;
  }

function normalizeMobileInput(value, selectedCountryCode) {
  if (!value) return null;

  const digits = value.replace(/\D/g, '');
  const code = String(selectedCountryCode || '');
  let localNumber = digits;

  // India: require exactly 10 local digits starting 6-9.
  if (code === '91') {
    if (localNumber.startsWith('91')) {
      localNumber = localNumber.slice(2);
    }
    if (localNumber.startsWith('0') && localNumber.length === 11) {
      localNumber = localNumber.slice(1);
    }
    if (!/^[6789]\d{9}$/.test(localNumber)) return null;
    return { countryCode: '91', localNumber, fullNumber: `+91${localNumber}` };
  }

  // Australia: require exactly 04XXXXXXXX local format.
  if (code === '61') {
    if (localNumber.startsWith('61')) {
      localNumber = localNumber.slice(2);
    }
    if (/^4\d{8}$/.test(localNumber)) {
      localNumber = `0${localNumber}`;
    }
    if (!/^04\d{8}$/.test(localNumber)) return null;
    return { countryCode: '61', localNumber, fullNumber: `+61${localNumber.slice(1)}` };
  }

  // USA: require a ten-digit NANP number with valid exchange prefixes.
  if (code === '1') {
    if (localNumber.startsWith('1') && localNumber.length === 11) {
      localNumber = localNumber.slice(1);
    }
    if (!/^[2-9]\d{2}[2-9]\d{6}$/.test(localNumber)) return null;
    return { countryCode: '1', localNumber, fullNumber: `+1${localNumber}` };
  }

  return null;
}

function resolveCountryDialCode(rawCode) {
  const code = String(rawCode || '').replace(/\D/g, '');
  if (code === '91' || code === '61' || code === '1') return code;
  return code.endsWith('91') ? '91' : '61';
}

const validationSchema = yup.object({
  memberid: yup
    .string("Enter valid Member ID")
    .matches(/^[A-Za-z0-9-_.]{3,20}$/, "Alphanumeric + (-._) only, 3-20 chars")
    .required("Member ID is required"),
    
  email: yup
    .string("Enter valid email")
    .email("Enter valid email format")
    .required("Email is required"),
    
  cardno: yup
    .string("Enter valid card number")
    .length(10,"Card number must be 10 characters")
    .matches(/^[0-9]+$/, "Numeric only, 10 characters")
    .required("Card number is required"),
    
  lastname: yup
    .string("Enter last name")
    .matches(/^[A-Za-z\s]{2,50}$/, "Letters + spaces only, 2-50 chars")
    .required("Last name is required"),
    
  firstname: yup
    .string("Enter first name")
    .matches(/^[A-Za-z\s]{2,50}$/, "Letters + spaces only, 2-50 chars")
    .required("First name is required"),
    
  cardexpiry_date: yup
    .string("Select expiry date")
    .nullable()                    // ✅ Allow null
    .required("Expiry date is required"),
  mobile: yup
    .string("Enter valid mobile number")
    .test('mobile-au-in', 'Enter valid mobile number', function(value) {
      if (!value || value.trim() === '') {
        return this.createError({ message: 'Mobile number is required' });
      }

      const trimmed = value.trim();
      const selectedCode = resolveCountryDialCode(this.parent.mobile_country_code || countryCode);
      const normalized = normalizeMobileInput(trimmed, selectedCode);
      if (!normalized) {
        return this.createError({ message: 'Enter valid mobile number' });
      }

      return true;
    })
    .required('Mobile number is required')
});
function handleSubmitError(err){
  notify(describeError(err), 'error');
  console.log("Error in submitting single pass creation:"+JSON.stringify(err?.response?.data || err?.message || err));
   }
   function handleSubmitSuccess(results){
  // The server's success message (if any) is shown by the global response interceptor.
console.log("Success in submitting single pass creation:"+JSON.stringify(results));
   }
     async function handleSubmit(values) {
       console.log(values);
       const selectedCode = resolveCountryDialCode(values.mobile_country_code || countryCode);
       const normalizedMobile = normalizeMobileInput(values.mobile, selectedCode);
       if (!normalizedMobile) {
        formik.setFieldTouched('mobile', true, false);
        formik.setFieldError('mobile', 'Enter valid mobile number');
        return;
       }
       const data= new FormData();
        data.append('issuer_id',user.issuerId);
        data.append('memberid',values.memberid);
        data.append('cardno',values.cardno);
        data.append('firstname',values.firstname);
        data.append('lastname',values.lastname);
        data.append('cardexpiry',values.cardexpiry_date);
        data.append('email',values.email);
        data.append('mobile',normalizedMobile.fullNumber);
         console.log("Submitting single pass creation:"+JSON.stringify(data));
          return axios.post(UrlHelperObj.memberpassUrl(),data,{headers: {
            'Content-Type': 'application/json'
         }})
        .then(response => response.data)
        .then(results => {handleSubmitSuccess(results); })
        .catch(err => {handleSubmitError(err); });   
    } 
// 🔍 CRITICAL DEBUG - Add this BEFORE return statement

function onClearForm() {
  formik.resetForm({
    values: {
      memberid: '',
      cardno: '',
      firstname: '',
      lastname: '',
      cardexpiry_date: '',
      email: '',
      mobile: `+${DEFAULT_PHONE_DIAL_CODE}`,
      mobile_country_code: DEFAULT_PHONE_DIAL_CODE
    }
  });
  formik.setFieldTouched('mobile', false, false);
  setCountryCode(DEFAULT_PHONE_DIAL_CODE);
  setSelectedCountry(DEFAULT_PHONE_COUNTRY);
  setPhoneResetSeed((prev) => prev + 1);
  setCardExpiryDate(null);
  setMessage(null);
  setIsErrorMessage(false);
  }
const formik = useFormik({
        enableReinitialize:true,
        validationSchema: validationSchema,
        initialValues:{
            memberid:'',
            cardno:'',
            firstname: '',
            lastname:'',
            cardexpiry_date: '',
            email:'',
            mobile:`+${DEFAULT_PHONE_DIAL_CODE}`,
            mobile_country_code:DEFAULT_PHONE_DIAL_CODE,
            
        },

          onSubmit: async (values, { setSubmitting }) => {
           console.log("Form submit called"+JSON.stringify(values));
            try {
            await handleSubmit(values);
            } finally {
            setSubmitting(false);
            }
            
               // values.valid_from_time = values.valid_from_time_str;
               // values.valid_to_time = values.valid_to_time_str;
               // props.handleSubmit(values,isAddOperation,false);
            
     
        },
     
    });

useEffect(() => {
  if (message !== null) {
    setMessage(null);
    setIsErrorMessage(false);
  }
}, [
  formik.values.firstname,
  formik.values.lastname,
  formik.values.cardno,
  formik.values.cardexpiry_date,
  formik.values.memberid,
  formik.values.email,
  formik.values.mobile,
  cardExpiryDate
]);

  const isAllFieldsEntered =
    formik.values.firstname.trim() !== '' &&
    formik.values.lastname.trim() !== '' &&
    formik.values.cardno.trim() !== '' &&
    formik.values.cardexpiry_date !== '' &&
    formik.values.memberid.trim() !== '' &&
    formik.values.email.trim() !== '' &&
    formik.values.mobile.trim() !== '';

  const cardExpiryErrorText = formik.touched.cardexpiry_date && !formik.values.cardexpiry_date
    ? formik.errors.cardexpiry_date
    : '';
  const hasCardExpiryError = Boolean(cardExpiryErrorText);

  const isSubmitDisabled = !isAllFieldsEntered || !formik.isValid || formik.isSubmitting;
  const leftFieldStyle = { width: isMobile ? '100%' : '80%' };
  const rightFieldStyle = { width: isMobile ? '100%' : '80%', marginLeft: isMobile ? 0 : '-100px' };


/* useEffect(() => {
  console.log("🔍 FORMIK DEBUG:", {
    isValid: formik.isValid,
    errors: formik.errors,
    values: formik.values,
    touched: formik.touched,
    isSubmitting: formik.isSubmitting
  });
}, [formik.isValid, formik.errors, formik.values]); */

// Test button click manually
/* const testSubmit = () => {
  console.log("🧪 MANUAL SUBMIT TEST");
  formik.submitForm();
}; */
  return (
    <form onSubmit={formik.handleSubmit} noValidate style={{ marginLeft: isMobile ? 0 : 10 }}>
                {/* <Grid container spacing={2}> */}
           <Grid container item xs={12} style={{textAlign:'left',borderStyle:'none',borderColor:'greeen'}}>
                <Grid item xs={12}>
            <Paper style={{ padding: '8px 12px' }}>
        <Typography variant={isMobile ? 'h6' : 'h5'} style={{ textAlign:'left' }}>Issue Single Membership Pass</Typography>
                    </Paper>
                </Grid>
            </Grid>
                    <Grid  item container xs={12} spacing={2}
            justifyContent="flex-start"  style={{ borderStyle: 'none', borderColor: 'black' }}
            alignItems='flex-start' direction="row">
                {/* <Grid container spacing={{xs:2,md:5}} direction="row" columns={{xs:4,sm:8,md:12}}> */}
                            <Grid item xs={12} sm={12} md={12}  >
                            </Grid>
                            
                            <Grid item  xs={12} sm={6} md={6}  >
                                <TextField
                                    required
                                  style={leftFieldStyle}
                                    variant='outlined'
                                    id="firstname"
                                    name="firstname"
                                    label="First Name"
                                    value={formik.values.firstname}
                                     onBlur={formik.handleBlur}  
                                    onChange={formik.handleChange}
                                    error={formik.touched.firstname && Boolean(formik.errors.firstname)}
                                    helperText={formik.touched.firstname && formik.errors.firstname}
                                />
                            </Grid>
                            <Grid item  xs={12} sm={6} md={6}  >
                                <TextField
                                required
                              style={rightFieldStyle}
                                variant='outlined'
                                    id="lastname"
                                    name="lastname"
                                    label="Last Name"
                                    value={formik.values.lastname}
                                      onBlur={formik.handleBlur}   
                                    onChange={formik.handleChange}
                                    error={formik.touched.lastname && Boolean(formik.errors.lastname)}
                                    helperText={formik.touched.lastname && formik.errors.lastname}
                                />
                            </Grid>
                            <Grid item  xs={12} sm={6} md={6}  >
                                <TextField
                                required
                                  style={leftFieldStyle}
                                    variant='outlined'
                                    id="cardno"
                                    //disabled={!isAddOperation}
                                    name="cardno"
                                    label="Card Number"
                                    value={formik.values.cardno}
                                    onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}   
                                    //type="string"
                                    error={formik.touched.cardno && Boolean(formik.errors.cardno)}
                                    helperText={formik.touched.cardno && formik.errors.cardno}
                                />
                                 
                                </Grid>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <Grid item xs={12} sm={6} md={6}  >
                                  <DatePicker
                                    label="Card expiry date"
                                    value={cardExpiryDate}
                                    disablePast
                                    inputFormat="dd/MM/yyyy"
                                    onChange={handleChangeCardExpiryDate}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        required
                                        style={rightFieldStyle}
                                        variant="outlined"
                                        id="cardexpiry_date"
                                        name="cardexpiry_date"
                                        InputLabelProps={{ shrink: true }}
                                        error={hasCardExpiryError}
                                        helperText={cardExpiryErrorText}
                                      />
                                    )}
                                  />
                                </Grid>
                                </LocalizationProvider>

                                <Grid item  xs={12} sm={6} md={6}  >
                                  <TextField
                                  required
                                    style={leftFieldStyle}
                                    variant='outlined'
                                    id="memberid"
                                    name="memberid"
                                    label="Member ID"
                                      onBlur={formik.handleBlur}   
                                    value={formik.values.memberid}
                                    onChange={formik.handleChange}
                                    error={formik.touched.memberid && Boolean(formik.errors.memberid)}
                                    helperText={formik.touched.memberid && formik.errors.memberid}
                                  />
                                </Grid>

                                <Grid item  xs={12} sm={6} md={6}  >
                                <TextField
                                required
                                style={rightFieldStyle}
                                variant='outlined'
                                    id="email"
                                    //disabled={!isAddOperation}
                                    name="email"
                                    label="Email"
                                    value={formik.values.email}
                                      onBlur={formik.handleBlur}   
                                    onChange={formik.handleChange}
                                    error={formik.touched.email && Boolean(formik.errors.email)}
                                    helperText={formik.touched.email && formik.errors.email}
                                />
                            </Grid>
                                <Grid item  xs={12} sm={6} md={6}  >
                                <PhoneInput inputProps={{
                                    name: 'phone',
                                    required: true                            
                                  }} 
                                  key={`phone-${phoneResetSeed}`}
                                  required
                                  value={formik.values.mobile || `+${DEFAULT_PHONE_DIAL_CODE}`}
                                  disableCountryGuess={false}
                                  disableInitialCountryGuess={false}
                                  countryCodeEditable={false}
                                  containerStyle={{width: isMobile ? '100%' : '80%'}}
                                  inputStyle={{width:'100%', height:'56px'}}
                                  placeholder=""
                                  copyNumbersOnly={false}
                                  country={resolvedSelectedCountry} 
                                  preferredCountries={['au','in','us']}
                                  onlyCountries={allowedPhoneCountries}
                                  preserveOrder={['onlyCountries']}
                                  onChange={ (phone,ctr) => onChangeMobile(phone,ctr)} // called a function instead of changing here
                                  onBlur={() => formik.setFieldTouched('mobile', true, true)}
                                  />
                            </Grid>
                            
                            
                            

                    </Grid>
                    <Grid container item xs={12}
                     direction={isMobile ? "column" : "row"} spacing={isMobile ? 1 : 3}
                      style={{ borderStyle: 'none', borderColor: 'black', marginTop: 24 }} justifyContent='flex-start'>
                        <Grid item xs={isMobile ? 12 : 'auto'}>
                          <Button
                            type='submit'
                            disabled={isSubmitDisabled}
                            variant='contained'
                            fullWidth={isMobile}
                            style={{
                              marginLeft: '2px',
                              backgroundColor: isSubmitDisabled ? '#bdbdbd' : 'blue',
                              color: isSubmitDisabled ? '#616161' : '#ffffff',
                              opacity: 1,
                              boxShadow: isSubmitDisabled ? 'none' : undefined,
                              cursor: isSubmitDisabled ? 'not-allowed' : undefined
                            }}
                          >
                            Submit
                          </Button>
                            {/* {props.progress}
                            <CircularProgress variant="determinate" value={props.progress} /> */}
                        </Grid>
                        <Grid item xs={isMobile ? 12 : 'auto'}>
                          <Button type='button' onClick={onClearForm}  color='secondary' variant='contained' fullWidth={isMobile}> Clear</Button>
                        </Grid>
                        <Grid item xs={isMobile ? 12 : 'auto'}>
                          <Button type='button' onClick={() => history.push(user?.issuerId ? `/club/${user.issuerId}/home` : '/')} color='secondary' variant='contained' fullWidth={isMobile}> Cancel</Button>
                        </Grid>
                    </Grid>
                {/* </Grid> */}
            </form>
   
  );
}

export default SinglePassCreation;
